const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy"
  return newImage;
}

const isHidden = (elem) => {
  const styles = window.getComputedStyle(elem);
  return styles.display === "none" || styles.visibility === "hidden";
}

// Initialize all product card swipers with navigation and pagination
const initProductCardSwipers = () => {
  document.querySelectorAll('.product-card-js').forEach((sliderElem) => {
    if (sliderElem.swiper) return; // already initialized

    // Find navigation buttons inside this slider
    const prevEl = sliderElem.querySelector('.swiper-button-prev');
    const nextEl = sliderElem.querySelector('.swiper-button-next');
    const paginationEl = sliderElem.querySelector('.swiper-pagination');

    // Prepare navigation object only if both buttons exist
    let navigation = false;
    if (prevEl && nextEl) {
      navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    }

    new Swiper(sliderElem, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 400,
      pagination: paginationEl ? {
        el: paginationEl,
        type: 'bullets',
        clickable: true,
      } : false,
      navigation: navigation,
      on: {
        init: function () {
          if (this.pagination && this.pagination.el) this.pagination.update();
        },
        slideChange: function () {
          if (this.pagination && this.pagination.el) this.pagination.update();
        }
      }
    });
  });
};

const checkSwatches = () => {
  // Ensure all sliders are initialized
  initProductCardSwipers();

  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.removeEventListener('click', handleVariantClick);
      input.addEventListener('click', handleVariantClick);

      function handleVariantClick(event) {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        const mediaWrappers = wrapper.querySelectorAll(".swiper.product-card-js");
        let hasActiveSlider = false;
        let variantInSlider = false;
        let targetSlider = null;
        let targetSlideIndex = -1;
        const variantMediaId = event.currentTarget.dataset.variantMedia;

        mediaWrappers.forEach((elem) => {
          if (!isHidden(elem) && elem.swiper) {
            hasActiveSlider = true;
            if (variantMediaId) {
              const allSlides = Array.from(elem.swiper.slides);
              const foundIndex = allSlides.findIndex(slide => {
                const slideMediaId = slide.dataset?.mediaId ? String(slide.dataset.mediaId).trim() : '';
                const targetMediaId = String(variantMediaId).trim();
                if (slideMediaId && slideMediaId === targetMediaId) return true;
                if (slide.querySelector(`[data-media-id="${targetMediaId}"]`)) return true;
                return false;
              });
              if (foundIndex !== -1) {
                variantInSlider = true;
                targetSlideIndex = foundIndex;
                targetSlider = elem.swiper;
              }
            }
          }
        });

        if (event.currentTarget.checked && primaryImage) {
          // Update add-to-cart button if present
          const addBtn = wrapper.querySelector('.card__add-to-cart button[name="add"]');
          if (addBtn) {
            addBtn.setAttribute('aria-disabled', false);
            const span = addBtn.querySelector('span');
            if (span) span.classList.remove('hidden');
            const soldOut = addBtn.querySelector('.sold-out-message');
            if (soldOut) soldOut.classList.add('hidden');
            const idInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');
            if (idInput) idInput.value = event.currentTarget.dataset.variantId;
          }

          // Update overlay link if present (for non-slider cards)
          const link = wrapper.querySelector('.js-color-swatches-link');
          if (link) link.setAttribute('href', event.currentTarget.dataset.variantLink);

          if (variantInSlider && targetSlider) {
            // Slide to the variant's media
            if (targetSlider.params?.loop) {
              targetSlider.slideToLoop(targetSlideIndex);
            } else {
              targetSlider.slideTo(targetSlideIndex);
            }
            if (targetSlider.pagination?.el) targetSlider.pagination.update();
          } else {
            // Fallback: replace primary image (for non-slider or if variant media not found)
            const currentColor = event.currentTarget.value;
            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage && !hasActiveSlider) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;
                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove('media--second');
                      secondaryImage.classList.add('media--first');
                      flag = true;
                    }
                  }
                  if (flag == false) {
                    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                    setTimeout(function () {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                      if (secondaryImage && !hasActiveSlider) secondaryImage.remove();
                      if (hasActiveSlider) {
                        mediaWrappers.forEach((elem) => {
                          if (!isHidden(elem) && elem.swiper) {
                            elem.swiper.slideTo(0);
                            if (elem.swiper.pagination?.el) elem.swiper.pagination.update();
                          }
                        });
                      }
                    }, 200);
                  }
                }
              }
            });
          }
        }
      }
    });
  });
}

function colorSwatches() {
  checkSwatches();
  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();